import { apiClient } from './client';

export interface Notification {
  id: number;
  userId: number;
  type: string;
  title: string;
  message: string;
  courrierId?: number;
  isRead: boolean;
  metadata?: any;
  createdAt: string;
  expiresAt?: string;
  courrier?: {
    id: number;
    reference: string;
    subject: string;
  };
}

export interface NotificationResponse {
  notifications: Notification[];
  total: number;
  unreadCount: number;
}

export const notificationService = {
  /**
   * Récupérer toutes les notifications de l'utilisateur
   */
  getNotifications: async (): Promise<Notification[]> => {
    const response = await apiClient.get<any>('/notifications');
    return response.data || [];
  },

  /**
   * Récupérer les notifications non lues
   */
  getUnreadNotifications: async (): Promise<Notification[]> => {
    const response = await apiClient.get<any>('/notifications?unreadOnly=true');
    return response.data || [];
  },

  /**
   * Marquer une notification comme lue
   */
  markAsRead: async (notificationId: number): Promise<void> => {
    await apiClient.patch(`/notifications/${notificationId}/read`);
  },

  /**
   * Marquer toutes les notifications comme lues
   */
  markAllAsRead: async (): Promise<void> => {
    await apiClient.patch('/notifications/read-all');
  },

  /**
   * Supprimer une notification
   */
  deleteNotification: async (notificationId: number): Promise<void> => {
    await apiClient.delete(`/notifications/${notificationId}`);
  },

  /**
   * Récupérer le nombre de notifications non lues
   */
  getUnreadCount: async (): Promise<number> => {
    const response = await apiClient.get<any>('/notifications/unread-count');
    return response.data?.unreadCount || 0;
  },
};